import { render, staticRenderFns } from "./SceneManage.vue?vue&type=template&id=0fa2b56c&scoped=true"
import script from "./SceneManage.vue?vue&type=script&lang=js"
export * from "./SceneManage.vue?vue&type=script&lang=js"
import style0 from "./SceneManage.vue?vue&type=style&index=0&id=0fa2b56c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa2b56c",
  null
  
)

export default component.exports